import type { PerformanceDatapoint } from 'owa-analytics';
import type ItemReadingPaneViewState from '../store/schema/ItemReadingPaneViewState';

// WeakMap is to keep telemetry outside observable view state to avoid renders, while allowing collection when the state is released.
const printDatapoints = new WeakMap<ItemReadingPaneViewState, PerformanceDatapoint>();

export function registerPrintDatapoint(
    viewState: ItemReadingPaneViewState,
    printDatapoint: PerformanceDatapoint
): void {
    printDatapoints.set(viewState, printDatapoint);
}

export function getPrintDatapoint(
    viewState: ItemReadingPaneViewState
): PerformanceDatapoint | undefined {
    return printDatapoints.get(viewState);
}

export function removePrintDatapoint(viewState: ItemReadingPaneViewState): void {
    printDatapoints.delete(viewState);
}
